function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.66 33.391c0-2.169.359-4.249 1.001-6.198L3.424 18.599A33.416 33.416 0 0 0 0 33.391a33.41 33.41 0 0 0 3.419 14.782l11.232-8.611a19.78 19.78 0 0 1-.991-6.171z",
  fill: "#fbbc05"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.391 13.66c4.705 0 8.955 1.67 12.294 4.402l9.714-9.714C49.479 3.187 41.89 0 33.391 0A33.288 33.288 0 0 0 3.424 18.599l11.237 8.593a19.682 19.682 0 0 1 18.73-13.532z",
  fill: "#ea4335"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.661 39.589L3.424 48.182a33.286 33.286 0 0 0 29.967 18.599c8.144 0 15.92-2.896 21.756-8.322L44.48 50.201c-3.01 1.899-6.8 2.92-11.089 2.92a19.68 19.68 0 0 1-18.73-13.532z",
  fill: "#34a853"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M65.264 33.391c0-1.973-.304-4.098-.759-6.071H33.391v12.901H51.3c-.896 4.399-3.333 7.781-6.82 9.981l10.667 8.258c6.129-5.698 10.117-14.185 10.117-25.069z",
  fill: "#4285f4"
});

var SvgIconGoogleg = function SvgIconGoogleg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 65.264 66.782",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconGoogleg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-googleg.785bd361.svg";
export { ForwardRef as ReactComponent };